export const TOTAL_CREATED_QUOTATIONS = 'TOTAL_CREATED_QUOTATIONS';
export const TOTAL_PENDING_EMISSIONS = 'TOTAL_PENDING_EMISSIONS';
export const TOTAL_PENDING_INSPECTIONS = 'TOTAL_PENDING_INSPECTIONS';
export const TOTAL_EMITTED_POLICIES = 'TOTAL_EMITTED_POLICIES';
export const TOTAL_CLOSED_QUOTATIONS = 'TOTAL_CLOSED_QUOTATIONS';
export const TOTAL_OPEN_QUOTATIONS = 'TOTAL_OPEN_QUOTATIONS';

export type QuotationStatusMetric =
  | 'TOTAL_PENDING_EMISSIONS'
  | 'TOTAL_PENDING_INSPECTIONS'
  | 'TOTAL_EMITTED_POLICIES';
